export const getPathMatch = ({ renderingLocale, pageNodes, pageId }) => {
  const pageContextMatch = pageNodes.find(
    ({ pageContext: { id, locale } }) =>
      id === pageId && locale === renderingLocale
  );

  return pageContextMatch?.path;
};
